<template>
    <div class="slide full" :style="slide.photo ? `background-image: url(${slide.photo});` : slide.backgroundColor ? `background-color: ${slide.backgroundColor};` : 'transparent;'">
        <Loading v-if="isLoading"></Loading>
        <h1><a href="#" @click.prevent="openSlidePanel">{{slide.title}}</a></h1>
        <h2>{{slide.subtitle}}</h2>
        <h3>{{slide.period}}</h3>
        <div><a class="plus" href="#" @click.prevent="openSlidePanel"></a></div>
        <img :src="slide.photo" alt="" v-if="slide.photo" v-show="false" @load="onImgLoad">
    </div>
</template>

<script>
import Loading from './Loading.vue';
import loaderLoaderMixin from '../mixins/loader';

export default {
    props: ['slide'],
    mixins: [loaderLoaderMixin],
    components: {Loading},
    methods: {
        openSlidePanel() {
            this.$root.$emit('openSlidePanel', this.slide.details)
        },
        onImgLoad() {
            this.isLoading = false;
        },
        goToNextSlide() {
            this.$root.$emit('goToNextSlide', true)
        }
    },
    mounted() {
        if (!this.slide.photo) {
            this.isLoading = false;
        }
    },
}
</script>

<style scoped>
.full {
    overflow: hidden;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}
h1 {
    margin-top: 0;
    margin-bottom: 20px;
    padding: 0 40px;
}
h1 a {
    font-weight: 400; 
    font-size: 56px;
    line-height: 1;
    text-shadow: 0px 0px 10px rgba(51,51,51,0.5);
    display: inline-block;
}
h1 a:hover, h1 a:focus {
    color: #fff; 
}
h1 a:after {
    content: ''; 
    display: block; 
    width: 0; 
    height: 3px; 
    background: #fff; 
    transition: width .3s;
}
h1 a:hover:after {
    width: 100%;
}
.slide.full h2 {
    margin-top: 0;
    margin-bottom: 10px;
    font-size: 2em;
    font-weight: 400;
    text-shadow: 0px 0px 6px rgba(51,51,51,0.5);
    padding: 0 40px;
}
.slide.full h3 {
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 1.5em;
    font-weight: 300;
    text-shadow: 0px 0px 4px rgba(51,51,51,0.8);
    padding: 0 40px;
}
.footer-home {
    position: absolute;
    bottom: 0;
    width: 100%;
    display: none;
}
.footer-home a {
    color: #fff;
    font-size: 100px;
}

/* MEDIA QUERIES */
@media (max-width: 575px) {
    h1 {
        margin-bottom: 10px;
    }
    h1 a {
        font-size: 36px;
    }
    .slide.full h2 {
        font-size: 1.5em;
        margin-bottom: 0px;
    }
    .slide.full h3 {
        font-size: 1.2em;
    }
    .footer-home {
        display: block;
    }
}
</style>